import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { HttpClientService } from '../common/http-client.service';

import { AutocompleteResult } from '../../models/autocomplete-result';

@Injectable({
  providedIn: 'root',
})
export class StylesheetService {
  /**
   * URL of stylesheets controller
   * @type {string}
   */
  private url: string = 'stylesheets';

  /**
   * Constructor
   * @param {HttpClientService} private httpClient Service to perform http requests with different methods
   */
  constructor(private httpClient: HttpClientService) {}

  /**
   * Autocomplete search by stylesheet name
   * @param  {[type]}                           term Term to search by
   * @return {Observable<AutocompleteResult[]>}      Server response with list of matching stylesheets
   */
  nameFieldSearch(term: string): Observable<AutocompleteResult[]> {
    return this.httpClient.getObservable(`${this.url}/autocomplete_stylesheet_name.json?term=${term}&typeahead=true`).pipe(map((response) => response as AutocompleteResult[]));
  }

  /**
   * Get stylesheet info for given id
   * @param  {[type]}       id Id of stylesheet to get info for
   * @return {Promise<any>}    Server response with stylesheet info
   */
  getStylesheetInfo(id: number): Promise<any> {
    return this.httpClient.get(`${this.url}/${id}.json`, {
      autocomplete_info: true,
    });
  }
}
